module.exports = __webpack_public_path__ + "static/media/metrocan-logo@3x.ddb9173f.png";